angular
  .module('jrCommonController', ['jrConfig'])
  .controller('MaskController', MaskController)
  .controller('SearchFormCtrl', SearchFormCtrl)
  .controller('MySearchesAsideCtrl', MySearchesAsideCtrl);

MaskController.$inject = ['$scope', '$rootScope', '$window', 'isMobile', 'MyProfileConfig'];
SearchFormCtrl.$inject = [
  'SearchFormService',
  'NavigationService',
  '$scope',
  'SearchConfig',
  'Messages',
];

MySearchesAsideCtrl.$inject = ['MySearchesService', '$scope'];

function MaskController($scope, $rootScope, $window, isMobile, MyProfileConfig) {
  $rootScope.menuOpened = false;
  $rootScope.overflow = false;
  $rootScope.mask = false;
  $rootScope.jobseekerFirstname = MyProfileConfig.firstname || '';
  $rootScope.jobseekerLastname = MyProfileConfig.lastname || '';
  $scope.tipClosed = false;

  // set main container min-height based on the left sidebar height
  const closeSidebarHeight = parseInt(
    angular.element(document.querySelector('.left-column .close-sidebar')).css('height'),
    10
  );
  const searchFiltersHeight = parseInt(
    angular.element(document.querySelector('.left-column .search-filters')).css('height'),
    10
  );
  const mainContainerHeight =
    closeSidebarHeight + searchFiltersHeight > $window.innerHeight
      ? closeSidebarHeight + searchFiltersHeight
      : $window.innerHeight;

  angular
    .element(document.querySelector('.main-container-row'))
    .css('min-height', mainContainerHeight);

  function clearOffsetMenus() {
    const mobileMenu = document.getElementsByClassName('mobile-menu')[0];
    const leftSidebar = document.getElementsByClassName('left-sidebar')[0];
    if (mobileMenu) {
      mobileMenu.style.top = '';
    }
    if (leftSidebar) {
      leftSidebar.style.top = '';
    }
  }

  $scope.toggleMobileMenus = function () {
    $rootScope.menuOpened = !$rootScope.menuOpened;
    const mobileMenuOpened = !!$rootScope.menuOpened;

    $rootScope.overflow = mobileMenuOpened;
    $rootScope.mask = mobileMenuOpened;
  };

  $scope.hideMask = function () {
    if ($rootScope.menuOpened === true) {
      $rootScope.menuOpened = !$rootScope.menuOpened;
    }

    if ($rootScope.overflow === true) {
      $rootScope.overflow = !$rootScope.overflow;
    }

    $rootScope.mask = !$rootScope.mask;

    if (isMobile) {
      clearOffsetMenus();
    }

    const opened = document.getElementsByClassName('opened');
    for (let i = 0; i < opened.length; i += 1) {
      angular.element(opened[0]).removeClass('opened');
    }
  };

  $scope.enableSearchForm = function () {
    $scope.$broadcast('EnableSearchForm');
  };

  angular.element($window).bind('orientationchange', (e) => {
    if (screen.width >= 768) {
      $rootScope.menuOpened = false;
      $rootScope.overflow = false;
      $rootScope.mask = false;
      $scope.$digest();
    }
  });

  $scope.closeTip = function () {
    $scope.tipClosed = true;
  };
}

function SearchFormCtrl(SearchFormService, NavigationService, $scope, SearchConfig, Messages) {
  $scope.mobileSearchFormEnabled = false;
  $scope.isEmptyWhere = !SearchFormService.search.where;
  $scope.isEmptyWhat = !SearchFormService.search.what;
  $scope.isEmptySearch = SearchFormService.search.isEmptySearch;
  $scope.initialWhat = '';
  $scope.initialWhere = '';
  $scope.whereClearButtonEnabled = !!SearchConfig.whereByIp;
  $scope.invalidSearchForm = false;
  $scope.distance = {
    value: SearchFormService.search.distance.value,
    autoexpanded: SearchFormService.search.distance.autoexpanded,
    label:
      SearchFormService.search.distance.value === 'auto'
        ? Messages.DistanceFiltersAutoTitle
        : `${Messages.SortFilterTitle}\xa0${SearchFormService.search.distance.text}`,
    enabled: !SearchConfig.geoCoordinatesNotPresent || !SearchFormService.search.where,
  };

  const smartphoneBanner = document.getElementsByClassName('smartphone-banner')[0];

  $scope.$on('EnableSearchForm', (event) => {
    $scope.enableSearchForm();
  });

  $scope.enableSearchForm = function () {
    $scope.mobileSearchFormEnabled = true;
    document.body.style.overflow = 'hidden';
    if (smartphoneBanner) {
      smartphoneBanner.style.display = 'none';
    }
  };

  $scope.disableSearchForm = function () {
    $scope.mobileSearchFormEnabled = false;
    document.body.style.overflow = '';
    document.getElementsByClassName('mobile-search-box')[0].scrollTop = 0;
    if (!$scope.search.what) {
      $scope.search.what = $scope.initialWhat;
    }
    if (!$scope.search.where) {
      $scope.search.where = $scope.initialWhere;
    }

    if (smartphoneBanner) {
      smartphoneBanner.style.display = 'block';
    }
  };

  $scope.$watch('search.country.value', (newValue, oldValue) => {
    // Redirect to different country
    if (newValue !== undefined && oldValue !== undefined) {
      NavigationService.toCountry(newValue);
    }
  });

  $scope.$watchCollection('search', (newValue) => {
    if (newValue !== undefined) {
      SearchFormService.search = angular.extend(SearchFormService.search, newValue);
    } else {
      $scope.search = angular.copy(SearchFormService.search);
    }
  });

  $scope.$watch('search.what', (newValue, oldValue) => {
    $scope.isEmptyWhat = !newValue;
    $scope.initialWhat = oldValue;
  });

  $scope.$watch('search.where', (newValue, oldValue) => {
    $scope.isEmptyWhere = !newValue;
    $scope.initialWhere = oldValue || '';
    $scope.distance.value = !newValue ? 'auto' : $scope.distance.value;
    $scope.distance.enabled = !$scope.isEmptyWhere;
    if ($scope.isEmptyWhere) {
      $scope.distance.label = Messages.DistanceFiltersAutoTitle;
    }
  });

  $scope.clearInput = function (inputType) {
    if (inputType === 'what') {
      $scope.isEmptyWhat = true;
      $scope.search.what = null;
    } else {
      $scope.isEmptyWhere = true;
      $scope.search.where = null;
      $scope.whereClearButtonEnabled = false;
    }
  };

  $scope.submit = function (event, isValid) {
    if (event) {
      event.preventDefault();
    }
    if (isValid) {
      $scope.invalidSearchForm = false;
      NavigationService.toSearch({
        what: $scope.search.what,
        where: $scope.search.where,
        distance: $scope.distance,
      });
    } else {
      $scope.invalidSearchForm = true;
    }
  };

  $scope.setSortyByFilter = function (value) {
    const sortByNewValue = $scope.search.sortBy === '' && value === 'relevance' ? '' : value;
    $scope.search.sortBy = sortByNewValue;

    jtag('event', 'click_sortby', {
      event_label: `${sortByNewValue}_filter`,
    });
  };

  $scope.setDistanceFilter = function (distance) {
    if ($scope.search.where) {
      $scope.distance.value = distance.value;
      $scope.distance.label =
        distance.value === 'auto'
          ? Messages.DistanceFiltersAutoTitle
          : `${Messages.SortFilterTitle}\xa0${distance.text}`;
    }
  };
}

function MySearchesAsideCtrl(MySearchesService, $scope) {
  $scope.$watch(
    () => MySearchesService.statements,
    (statements) => {
      $scope.statements = angular.copy(statements);
    },
    true
  );
}
